
import { defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import Banner from '@/components/banner/Banner.vue';
import SearchIcon from '@/components/icons/SearchIcon.vue';
import { getPartList, getPartPartsList } from '@/api/apis';
import CatalogueItem from './CatalogueItem.vue';

export default defineComponent({
  name: 'Catalogue',
  components: {
    SearchIcon,
    CatalogueItem,
    Banner
  },
  data() {
    return {
      loading: false,
      loaded: false,
      catalogues: [],
      pageNo: 1,
      pageSize: 8,
      pageSizeOptions: ['8', '16'],
      current: 1,
      total: 0,
      partNameQueryParam: {
        name: ''
      },
      partNoQueryParam: {
        modelNum: ''
      },
      // params & query
      vehicleId: 0,
      model: ''
    };
  },
  created() {
    const route = useRoute();

    const params = route.params;

    const query = route.query;

    this.model = query.model as string;

    if (params.vehicleId) {
      this.vehicleId = Number(params.vehicleId);

      if (this.vehicleId > 0) {
        this.loadData();
      }
    }
  },
  methods: {
    onShowSizeChange() {
      this.pageNo = 1;
      this.loadData();
    },
    onChange() {
      this.loadData();
    },
    async loadData() {
      this.loading = true;

      const res = await getPartList({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        vehicleId: this.vehicleId,
        type: 1 // 图册
      });

      if (res.success) {
        const data = res.result || {};

        this.catalogues = data.records || [];
        this.total = data.total;
      }

      this.loading = false;

      this.loaded = true;
    },
    getSearchBtn1Style() {
      const isActive = !!this.partNoQueryParam.modelNum;
      return {
        width: 'auto',
        'background-color': !isActive ? '#E5EAF4' : '#039'
      };
    },
    getSearchBtn2Style() {
      const isActive = !!this.partNameQueryParam.name;
      return {
        width: 'auto',
        'background-color': !isActive ? '#E5EAF4' : '#039'
      };
    },
    onSearchNo() {
      const form = (this.$refs as any).numForm;

      form
        .validate()
        .then(async () => {
          const res = await getPartPartsList({
            modelNum: this.partNoQueryParam.modelNum
              ? this.partNoQueryParam.modelNum.trim()
              : '',
            vehicleId: this.vehicleId
          });
          if (res.success) {
            const data = res.result || {};
            const hasResult = data.total >= 2;
            if (data.total === 1) {
              window.open(
                `/partdetail/${data.records[0].id}?modelNum=${this.partNoQueryParam.modelNum}`
              );
            } else {
              window.open(
                `/part-result?isNo=1&modelNum=${
                  this.partNoQueryParam.modelNum
                }&vehicleId=${this.vehicleId}&hasResult=${Number(hasResult)}`
              );
            }
          }
        })
        .catch();
    },
    onSearchName() {
      const form = (this.$refs as any).nameForm;
      form
        .validate()
        .then(async () => {
          const res = await getPartPartsList({
            partName: this.partNameQueryParam.name
              ? this.partNameQueryParam.name.trim()
              : '',
            vehicleId: this.vehicleId
          });
          if (res.success) {
            const data = res.result || {};
            const hasResult = data.total >= 2;
            if (data.total === 1) {
              window.open(
                `/partdetail/${data.records[0].id}?name=${this.partNameQueryParam.name}`
              );
            } else {
              window.open(
                `/part-result?isNo=0&partName=${
                  this.partNameQueryParam.name
                }&vehicleId=${this.vehicleId}&hasResult=${Number(
                  hasResult
                )}&model=${this.model || ''}`
              );
            }
          }
        })
        .catch();
    },
    onSearchModelNumChange() {
      if (!this.partNoQueryParam.modelNum) {
        const form = (this.$refs as any).numForm;

        this.$nextTick(() => {
          form.clearValidate('modelNum');
        });
      }
    },
    onSearchNameChange() {
      if (!this.partNameQueryParam.name) {
        const form = (this.$refs as any).nameForm;

        this.$nextTick(() => {
          form.clearValidate('name');
        });
      }
    }
  }
});
